import { observer } from 'mobx-react'
import { FC } from 'react'
import { uiController } from '@/controllers/uiController'
import { commonUtils } from '@/helpers/commonUtils'
// 移动端弹窗
import BuyPopup from '../mobile/BuyPopup/BuyPopup'
import PayingPopup from '../mobile/PayingPopup/PayingPopup'
import PaySuccessPopup from '../mobile/PaySuccessPopup/PaySuccessPopup'
import ContactPopup from '../mobile/ContactPopup/ContactPopup'
import LoginDialog from '../mobile/LoginDialog/LoginDialog'
import CustomerEntry from '../mobile/CustomerEntry/CustomerEntry'
import PackageExpiredPopup from '../mobile/PackageExpiredPopup/PackageExpiredPopup'
// PC 端弹窗
import PcLoginModal from '../pc/LoginModal/LoginModal'
import PcPaySuccessModal from '../pc/PaySuccessModal/PaySuccessModal'
import PcPayModal from '../pc/PayModal/PayModal'
import DownloadDialog from '../pc/DownloadDialog/DownloadDialog'
import PackageExpiredModal from '../pc/PackageExpiredModal/PackageExpiredModal'
import CustomerServiceModal from '@/components/pc/CustomerServiceModal/CustomerServiceModal'

interface CommonDialogLayoutProps {}

const CommonDialogLayout: FC<CommonDialogLayoutProps> = observer((props: CommonDialogLayoutProps) => {
  const isMobile = commonUtils.isMobile()
  if (isMobile) {
    return (
      <>
        <BuyPopup {...uiController.buyPopupProps} />
        <PayingPopup {...uiController.payingPopupProps} />
        <PaySuccessPopup {...uiController.paySuccessPopupProps} />
        <PackageExpiredPopup {...uiController.packageExpiredPopupProps} />
        <ContactPopup {...uiController.contactPopupProps} />
        <ContactPopup {...uiController.downloadConsultationQrCodePopupProps} />
        <LoginDialog {...uiController.loginDialogProps} />
        <CustomerEntry />
      </>
    )
  }
  return (
    <>
      {uiController.PcLoginModalProps && <PcLoginModal {...uiController.PcLoginModalProps} />}
      {uiController.PcPaySuccessModalProps && <PcPaySuccessModal {...uiController.PcPaySuccessModalProps} />}
      {uiController.PcPayModalProps && <PcPayModal {...uiController.PcPayModalProps} />}
      {uiController.customerServiceModalProps.visible && (
          <CustomerServiceModal {...uiController.customerServiceModalProps} />
        )}
      {uiController.PcDownloadDialogProps && <DownloadDialog {...uiController.PcDownloadDialogProps} />}
      {uiController.PcPackageExpiredModalProps && (
        <PackageExpiredModal {...uiController.PcPackageExpiredModalProps} />
      )}
    </>
  )
})

export default CommonDialogLayout
